import { FEATURE_FLAGS } from "@cede/types";
import { useFeatureFlagIsOn } from "@/hooks/feature-flags";

export const useCampaignsTableFlags = () => {
  const showStart = useFeatureFlagIsOn(FEATURE_FLAGS.TABLE_DISPLAY_HUB_START);
  const showCurrentTradedVolume = useFeatureFlagIsOn(FEATURE_FLAGS.TABLE_DISPLAY_HUB_CURRENT_TRADED_VOLUME);
  const showDailyReward = useFeatureFlagIsOn(FEATURE_FLAGS.TABLE_DISPLAY_HUB_DAILY_REWARD);
  const showEpochEnds = useFeatureFlagIsOn(FEATURE_FLAGS.TABLE_DISPLAY_HUB_EPOCH_ENDS);
  const showParticipating = useFeatureFlagIsOn(FEATURE_FLAGS.TABLE_DISPLAY_HUB_PARTICIPATING);
  const showRule = useFeatureFlagIsOn(FEATURE_FLAGS.TABLE_DISPLAY_HUB_RULE);

  return {
    showStart,
    showCurrentTradedVolume,
    showDailyReward,
    showEpochEnds,
    showParticipating,
    showRule,
  };
};
